export const getAcceptLang = () => {
  const lang = localStorage.getItem('lang') || 'ru';
  return lang;
};
